import React, { FunctionComponent } from "react"

import noResultsImg from "assets/img/no-results.svg"

import Text from "components/Text/Text"

const SelectNoOptionsMessage: FunctionComponent<React.PropsWithChildren<unknown>> = ({
    children
}) => {
    return (
        <div className="py-4 text-center">
            <img src={noResultsImg} alt="" aria-hidden />
            <Text className="mt-2">{children}</Text>
        </div>
    )
}

export default SelectNoOptionsMessage
